export const TextareaSkeleton = ({
  label,
  htmlFor,
  helperText,
}: {
  label: string;
  htmlFor: string;
  helperText: string;
}) => (
  <div data-testid='dynamic-input-field'>
    <div className='flex flex-row items-center mb-2'>
      <label className='text-primary text-body-xs' htmlFor={htmlFor}>
        {label}
      </label>
    </div>
    <div className='w-full'>
      <div className='w-full h-24 bg-tertiary rounded-sm animate-pulse' />
      <p className='mt-1 text-xs text-secondary'>{helperText}</p>
    </div>
  </div>
);
